import { defineMessages } from 'react-intl';

export default defineMessages({
  Caption: {
    id: 'Image caption',
    defaultMessage: 'Image Caption',
  },
});
